module.exports = __webpack_public_path__ + "media/images/stories/256_rsz_jared-rice-388260-unsplash-aea2aa31dfdad58b6d42165098fb8a79.jpg";